import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectEventsQueryItems } from '../../../../../redux/event/events/selector';
import { events } from '../../../../../redux/event/events/action';
import { MyEventComponent } from '../components/event.component';

const Myevent = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const queryItems = useSelector(selectEventsQueryItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [
        selectedEvent,
        setSelectedEvent
    ] = useState<any>([])

    const fetchQueryById = () => {
        dispatch(events.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/event/events/query`, entity: 'events', jsonData: {

                Records: [
                    {
                        "Id": parmas?.id

                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })

    }
    useEffect(
        () => {

            if (parmas?.id > 0) {
                fetchQueryById()

            } else {
                setIsLoading(false)
            }

        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                const querydata: any = queryItems?.result?.items
                setSelectedEvent(querydata)

                const forumGroupsItemsData: any = queryItems?.result?.items?.ForumGroups?.map((item: any) => {
                    const itemData = {
                        Id: item?.Id,
                        Name: item?.Name,
                        Description: item?.Description,
                        DisplayOrder: item?.DisplayOrder,

                    }
                    return itemData
                })
            }
        },
        [isQuery]
    )

    const back = () => {
        navigate('/venture/events/myevents')
    }

    return (
        <>
            {isLoading ? <PageLoader /> :
                <MyEventComponent
                    selectedEvent={selectedEvent}
                    back={back}
                />
            }

        </>
    )

}

export default Myevent;